import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Paper, Stack, styled } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InquirySearchContainer from "../containers/InquirySearchContainer";
import RegistrationDetailsCard from "../components/RegistrationCard";
import InsightsDashboard from "../apps/inquiryAnalytics";
import { getAllInquiries, getAllInquiryTypes } from "../actions/inquiries";
import RegistrationReport from "../apps/reports/registration";
const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#D9D9D9",
  borderRadius: 10,
  padding: "20px 40px",
  textAlign: "center",
  height: "87vh",
  overflowY: "scroll",
}));

const InquiryList = () => {
  const dispatch = useDispatch();
  const inquiryList = useSelector((state) => state.inquiryList);
  const inquiryTypeList = useSelector((state) => state.inquiryTypeList);

  const { loading: isDataLoaded, inquiries } = inquiryList;
  const { loading: isDataLoaded2, inquiryTypes } = inquiryTypeList;

  const [formInfo, setFormInfo] = useState({
    inqueries: [],
    filteredInqueries: [],
  });

  const [searchParams, setSearchParams] = useState({
    searchTerm: "",
    isDomestic: "",
    type: "",
  });

  useEffect(() => {
    if (!isDataLoaded) {
      dispatch(getAllInquiries());
    }
    if (!isDataLoaded2) {
      dispatch(getAllInquiryTypes());
    }
  }, []);


  useEffect(() => {
    let filteredInquiries = formInfo.inqueries;

    if (searchParams.searchTerm !== "") {
      filteredInquiries = inquiries.filter((inquiry) =>
        inquiry.name.toLowerCase().includes(searchParams.searchTerm.toLowerCase())
      );
    }

    if (searchParams.type !== "") {
      filteredInquiries = filteredInquiries.filter(
        (inquiry) => parseInt(inquiry.InquiryType.id) === parseInt(searchParams.type)
      );
    }

    if (searchParams.isDomestic === "" && searchParams.type === "" && searchParams.searchTerm === "") {
      filteredInquiries = inquiries;
    }

    setFormInfo({
      ...formInfo,
      filteredInqueries: filteredInquiries,
    });
  }, [searchParams, formInfo.inqueries, inquiries]);

  return (
    <Stack direction="column" spacing={2}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography>Analytics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <InsightsDashboard inquiries={inquiries} />
        </AccordionDetails>
      </Accordion>

      <Container
     
      elevation={0} style={{ mt: 4 }}>
        {/* <InquirySearchContainer
          types={inquiryTypes?.map((d) => ({ value: d.id, label: d.name }))}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        /> */}

        {/* <RegistrationReport inquiries={formInfo} /> */}
        <RegistrationDetailsCard formInfo={formInfo} inquiries={inquiries} />
      </Container>
    </Stack>
  );
};

export default InquiryList;
